import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { withRouter } from 'react-router-dom';
import DetailUnscheduledList from './DetailUnscheduledList';

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

// const DragAndDropCalendar = withDragAndDrop(BigCalendar, { backend: false });

// let allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k]);
const allViews = ["day"]

const styles = theme => ({
    root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        flex: 1,
        '& .rbc-header': {
            padding: '12px 6px',
            fontWeight: 500,
            fontSize: 14
        },
        '& .rbc-label': {
            padding: '8px 6px',
        },
        '& .rbc-today': {
            backgroundColor: 'transparent'
        },
        '& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today': {
            borderBottom: '2px solid ' + theme.palette.secondary.main + '!important',
        },
        '& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view': {
            padding: 24,
            ...theme.mixins.border(0)
        },
        '& .rbc-agenda-view table': {
            ...theme.mixins.border(1),
            '& thead > tr > th': {
                ...theme.mixins.borderBottom(0)
            },
            '& tbody > tr > td': {
                padding: '12px 6px',
                '& + td': {
                    ...theme.mixins.borderLeft(1)
                }
            }
        },
        '& .rbc-time-view': {
            '& .rbc-time-header': {
                // ...theme.mixins.border(1)
                display: 'none'
            },
            '& .rbc-time-content': {
                flex: '0 1 auto',
                ...theme.mixins.border(1)
            }
        },
        '& .rbc-month-view': {
            '& > .rbc-row': {
                ...theme.mixins.border(1)
            },
            '& .rbc-month-row': {
                ...theme.mixins.border(1),
                borderWidth: '0 1px 1px 1px!important',
                minHeight: 128
            },
            '& .rbc-header + .rbc-header': {
                ...theme.mixins.borderLeft(1)
            },
            '& .rbc-header': {
                ...theme.mixins.borderBottom(0)
            },
            '& .rbc-day-bg + .rbc-day-bg': {
                ...theme.mixins.borderLeft(1)
            }
        },
        '& .rbc-day-slot .rbc-time-slot': {
            ...theme.mixins.borderTop(1),
            opacity: 0.5
        },
        '& .rbc-time-header > .rbc-row > * + *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-content > * + * > *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-day-bg + .rbc-day-bg': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-header > .rbc-row:first-child': {
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-timeslot-group': {
            minHeight: 64,
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-date-cell': {
            padding: 8,
            fontSize: 16,
            fontWeight: 400,
            opacity: .5,
            '& > a': {
                color: 'inherit'
            }
        },
        '& .rbc-event': {
            borderRadius: 0,
            // padding: '4px 8px',
            backgroundColor: theme.palette.primary.dark,
            minHeight: '30px',
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[0],
            transitionProperty: 'box-shadow',
            transitionDuration: theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position: 'relative',
            '&:hover': {
                boxShadow: theme.shadows[2]
            }
        },
        //Connor
        '& .rbc-event-label': {
            display: 'none'
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-off-range-bg': {
            backgroundColor: theme.palette.type === 'light' ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.16)'
        },
        '& .rbc-show-more': {
            color: theme.palette.secondary.main,
            background: 'transparent'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event': {
            position: 'static'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child': {
            left: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child': {
            right: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-toolbar-label': {
            display: 'none'
        },
        '& .rbc-btn-group': {
            display: 'none'
        }
    },
    addButton: {
        display: 'none'
    }
});

class DetailCalendar extends Component {

    state = {
        currentView: 'day',
        date: new Date(2018, 9, 1)
    }

    eventStyleGetter = (event, start, end, isSelected) => {
        // console.log(event)
        switch (event.eventType) {
            case ('assignment'): {
                let style = { backgroundColor: event.selected ? 'green' : event.Color }
                return { style: style }
            }
            case ('quiz'): {
                let style = { backgroundColor: event.selected ? '#B10DC9' : '#0074D9' }
                return { style: style }
            }
        }
    }

    render() {
        const { classes, events, dayEvents } = this.props
        const fullDayComponent = ({ event }) => (
            <div>
                <div style={{ fontSize: '12px' }} >{event.title} </div>
                <div style={{ fontSize: '10px' }} >{event.courseName} </div>
            </div>
        )

        const dayComponent = ({ event }) => (
            <div>  
                <div className='float-left' style={{paddingTop: '4px'}}>
                    {moment(event.start).format('h:mm A')} - {moment(event.end).format('h:mm A')}
                </div>
    
                <div className='float-right'>
                    {event.title}
                </div>
    
            </div>
        )

        if (this.props.currentLesson.Unscheduled === 1) {
            return (
                <DetailUnscheduledList events={dayEvents} />
            )
        }

        return (
            <div className={classes.root}>
                <Grid container spacing={24}>
                    <Grid item xs={12} style={{ width: '97%' }}>
                        <BigCalendar
                            popup
                            selectable
                            view={this.state.currentView}
                            // resizable
                            // onEventResize={this.resizeEvent}
                            className="flex flex-1"
                            events={dayEvents}
                            views={allViews}
                            showMultiDayTimes
                            defaultDate={new Date(2018, 9, 1)}
                            defaultView="day"
                            onSelectSlot={null}
                            date={this.state.date}
                            onNavigate={null}
                            eventPropGetter={(this.eventStyleGetter)}
                            components={{ event: fullDayComponent, day: { event: dayComponent } }}
                            onView={null}
                            min={new Date(moment().startOf('day').add(6, 'hours'))}
                            max={new Date(moment().startOf('day').add(20, 'hours'))}
                            step={30}
                            // onSelectEvent={event => {
                            //     console.log(event)
                            // }}
                        />

                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({  }) {
    return {
    }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(DetailCalendar)));


// WEBPACK FOOTER //
// src/main/content/lesson/ScheduleComponents/DetailSchedule.js